import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/themeFour/cash.png'
import _imports_1 from '@/assets/themeFour/btn2.png'
import _imports_2 from '@/assets/themeFour/btn1.png'


const _hoisted_1 = { class: "top-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "",
  width: "25%"
}
const _hoisted_5 = {
  key: 1,
  class: "header_button_item"
}
const _hoisted_6 = { class: "coin_btn" }
const _hoisted_7 = { style: {"padding-left":"5px"} }
const _hoisted_8 = { class: "balanceText" }

import { useRouter } from "vue-router";
import SideNavbar from "../sideNav/sideNavbar.vue"
import { ref, inject, computed, onMounted } from 'vue';
import { playClickSound } from "@/utils/media";
import { useUserStore } from "@/stores/user";
import { formatCurrency } from "@/utils/commonFunction";
import PwaDownloadCard from "../../home/components/pwaDownloadCard.vue";
// import ThemeChangePopup from "./themeChangePopup.vue";
import ContactServicePopup from "@/view/profile/contactServicePopup.vue";
import { safeNavigate } from "@/view/home/supportScript";

export default /*@__PURE__*/_defineComponent({
  __name: 'mainHeader',
  props: {
    itemData: {},
    listGameData: {}
  },
  emits: ['goToProfile', 'intallPWA', 'isClosedPWA', 'goToGamePanel', 'goToGameSearch', 'openSidebar', 'goToDeposit'],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const sideNavbarRef = ref()
const themeChangeRef = ref()
const batchContent = ref(0)
const token = ref(localStorage.getItem('token'))
const isLogin = ref(token.value ? true : false)
const userStore = useUserStore()
const balance = computed(() => userStore.balance)
const unreadMsgCount = computed(() => userStore.unreadCount)
const isRotating = ref(false);
const props = __props
const appIconData = ref({
    url: props.itemData.appIcon.url,
    display: props.itemData.appIcon.display
})

const listGameData = computed(() => props.listGameData);
const sideIconData = ref({
    url: props.itemData.sideIcon.url,
    display: props.itemData.sideIcon.display,
})
const userBalnceData = ref({
    display: props.itemData.userBalnce.display,
})
const searchButtonData = ref({
    display: props.itemData.searchButton.display,
})
const openSidebar = () => {
    if (isRotating.value) return;

    playClickSound();
    isRotating.value = true;

    emits('openSidebar');

    setTimeout(() => {
        isRotating.value = false;
    }, 1000);
}
const openRegisterPopup = (type: number) => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return }
    openRegisterLoginPopup?.(type)
}
const emits = __emit
const goToMessage = (event: Event) => {
    safeNavigate(router, '/sd-message', event)
}
const goToGamePannelSidePannel = (id: number) => {
    emits('goToGamePanel', id)
}
const goToDeposit = () => {
    playClickSound()
    emits('goToDeposit')
}
const handleThemeChange = () => {
    themeChangeRef.value.open()
}
const goToGameSearch = () => {
    emits('goToGameSearch')
}

onMounted(() => {
    appIconData.value.url = props.itemData.appIcon.url
    appIconData.value.display = props.itemData.appIcon.display

    sideIconData.value.url = props.itemData.sideIcon.url
    sideIconData.value.display = props.itemData.sideIcon.display

    userBalnceData.value.display = props.itemData.userBalnce.display

})

const intallPWA = () => {
    emits('intallPWA');
}

const isClosedPWA = (value: any) => {
    emits('isClosedPWA', value);
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PwaDownloadCard, {
      onIntallPWA: intallPWA,
      onIsClosedPWA: isClosedPWA
    }),
    _createVNode(_component_van_row, {
      class: "header",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "2",
          onClick: openSidebar,
          class: "header_item_menu"
        }, {
          default: _withCtx(() => [
            (sideIconData.value.display)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: sideIconData.value.url,
                  alt: ""
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: _unref(userStore).loginAccount ? 10 : 10,
          class: "header_item_logo"
        }, {
          default: _withCtx(() => [
            (appIconData.value.display)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: appIconData.value.url,
                  alt: ""
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["span"]),
        (_unref(userStore).loginAccount)
          ? (_openBlock(), _createBlock(_component_van_col, {
              key: 0,
              style: {"display":"flex","justify-content":"right"},
              span: "11",
              align: "right"
            }, {
              default: _withCtx(() => [
                (userBalnceData.value.display)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                  : _createCommentVNode("", true),
                (userBalnceData.value.display)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _cache[4] || (_cache[4] = _createElementVNode("span", { style: {} }, "R$ ", -1)),
                          _createTextVNode(_toDisplayString(_unref(formatCurrency)(balance.value)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('home.balance')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_unref(userStore).loginAccount)
          ? (_openBlock(), _createBlock(_component_van_col, {
              key: 1,
              span: "11",
              class: "header_button_item",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_row, { style: {"width":"100%"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_col, {
                      span: "11",
                      class: "btnContainer"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (openRegisterPopup(1))),
                          src: _imports_1,
                          alt: "",
                          width: "100%",
                          height: "100%"
                        }),
                        _createElementVNode("div", {
                          class: "registerLoginBtn",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (openRegisterPopup(1)))
                        }, _toDisplayString(_ctx.$t('common.login')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_col, {
                      span: "12",
                      offset: "1",
                      class: "btnContainer"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (openRegisterPopup(0))),
                          src: _imports_2,
                          alt: "",
                          height: "100%",
                          width: "100%"
                        }),
                        _createElementVNode("div", {
                          class: "registerLoginBtn",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (openRegisterPopup(0)))
                        }, _toDisplayString(_ctx.$t('common.register')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})